import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import type { ApiGroup } from "@/generated/models/ApiGroup";
import { getScaledImageUri, ImageScale } from "@/helpers/image.helpers";
export default function WaveGroupScope(t0) {
  const $ = _c(9);
  const {
    group
  } = t0;
  if (group.is_hidden) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <span className="tw-font-medium tw-text-iron-50">Hidden</span>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  const t1 = `/network?page=1&group=${group.id}`;
  let t2;
  if ($[1] !== group.author) {
    t2 = group.author?.pfp ? <img className="tw-h-5 tw-w-5 tw-rounded-md tw-bg-iron-800/80 tw-shadow-sm" src={getScaledImageUri(group.author.pfp, ImageScale.W_AUTO_H_50)} alt={group.author.handle ?? ""} /> : <div className="tw-h-5 tw-w-5 tw-rounded-md tw-bg-iron-800/80" />;
    $[1] = group.author;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== group.name) {
    t3 = <div className="tw-max-w-40 tw-truncate tw-font-medium tw-underline tw-transition tw-duration-300 tw-ease-out desktop-hover:group-hover:tw-text-iron-400">{group.name}</div>;
    $[3] = group.name;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t1 || $[6] !== t2 || $[7] !== t3) {
    t4 = <Link href={t1} className="tw-flex tw-items-center tw-gap-x-1.5 tw-text-iron-50 tw-no-underline desktop-hover:hover:tw-text-iron-200 desktop-hover:hover:tw-underline">{t2}{t3}</Link>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}